<div class="dialog-header">
  <button class="close-button" color="primary" [matTooltip]="'shared.labels.close'|translate"
  [mat-dialog-close]="false" mat-icon-button>
      <mat-icon>close</mat-icon>
  </button>
</div>
<img src="assets/images/interest.jpg">
